module.exports = __webpack_public_path__ + "img/常态化宣传.590049d5.jpg";